import Vue from 'vue';  
export const EventEmmiter = new Vue();